<style scoped lang="scss">
    .messages {
        border: thin solid #bbb;
    }
</style>

<template>
    <div class="uk-grid">
        <div class="uk-width-medium-8-10 uk-align-center">
            <div class="uk-panel">
                <h3 class="uk-panel-title">My Messages</h3>
                <ul class="uk-comment-list messages">
                    <message-list-item v-for="(message,i) in communications"
                                       :key="message.id"
                                       :user="user"
                                       @updated="onMessageUpdated"
                                       :message="message"/>
                </ul>
            </div>

        </div>
    </div>
</template>

<script>
    import MessageListItem from "../../components/Messages/MessageListItem";
    export default {
        name: "Messages",
        components: {MessageListItem},
        data() {
            return {
                communications: [],
                showCreateModal: false,
                user: {}
            }
        },
        mounted() {
            this.getData();

        },
        methods: {
            getData() {
                axios.get('/api/hope/me').then(r => {
                    this.user = r.data.user;
                })
                axios.get('/api/hope/communications').then(r => {
                    this.communications = r.data.communications;
                })
            },

            onMessageUpdated($event) {
                let newMessages = [];
                for(var i in this.communications) {
                    let message = this.communications[i];
                    if(message.id == $event.message.id) {
                        newMessages.push($event.message);
                    }else {
                        newMessages.push(message);
                    }
                }
                this.communications = newMessages;
            }

        }
    }
</script>
